import React, { useState } from "react";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const [status, setStatus] = useState(""); // success / error message
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus("");

    const data = {
      access_key: "33758703-84b6-45b7-b677-a2d8023e3622", 
      name: formData.name,
      phone: formData.phone,
      email: formData.email,
      message: formData.message,
      subject: "New Property Enquiry",
      from_name: "Saptveda venture",
    };

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      });

      const result = await response.json();

      if (result.success) {
        setStatus("Form is submitted successfully ✅");
        setFormData({
          name: "",
          phone: "",
          email: "",
          message: "",
        });
           setTimeout(() => {
          setStatus("");
        }, 5000);
      } else {
        setStatus("Something went wrong ❌ Please try again.");
      }
    } catch (error) {
      setStatus("Network error ❌ Please try again.");
    }

    setLoading(false);
  };

  return (
    <section className="contact-section">
      <div className="backdiv">
        <div className="contact-container">

          <div className="contact-left">
            <h2 className="sapt-head">Get in Touch</h2>
            <p className="main-content">
              Looking to buy, invest, or schedule a site visit?  
              Leave your details and our property expert will call you shortly.
            </p>

            <div className="d-flex align-items-center justify-content-center">
              <div className="person-image">  
                <img src="./call-us.webp" alt="person" className="img-cover"/>
              </div>
            </div>
          </div>

          <form className="form_connect" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Full Name"
              value={formData.name}
              onChange={handleChange}
              required
            />

            <input
              type="tel"
              name="phone"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={handleChange}
              required
            />

            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
            />

            <textarea
              name="message"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
              rows="4"
            ></textarea>

            <button className="rqst_btn" disabled={loading}>
              {loading ? "Submitting..." : "Request Call Back"}
            </button>

            {/* Status Message */}
            {status && <p className="form-status">{status}</p>}
          </form>

        </div>
      </div>
    </section>
  );
};

export default ContactForm;
